{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":128,
                 "y":192
                }, 
                {
                 "ellipse":true,
                 "height":96,
                 "id":6,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":96,
                 "x":448,
                 "y":160
                }, 
                {
                 "height":192,
                 "id":9,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":288,
                 "y":128
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":10,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 2"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":1
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}